import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-iamark-count-report',
  templateUrl: './iamark-count-report.component.html',
  styleUrls: ['./iamark-count-report.component.scss']
})
export class IAMarkCountReportComponent implements OnInit {
IAReport: FormGroup
  UserCollege: any;
  userPermission: any;
  collegeList: any[];
  filteredCollegeList: any[];
  CourseList: any[];
  filteredCourseList: any[];
  ExamAList: any[];
  filteredExamAList: any[];
  Table = false;
  sessionList: any[];
  SessionFilterList: any[];
  ExamFormStudentList: any;
  filteredExamFormStudentList: any;
  TotalAllStudents: any;
  TotalExamSubmittedRecords: any;
  BranchList: any;
  filteredListHead: any[];
  head: any;
  headcode: any;
  subcode: string;
  filteredsubjectList: any[];
  subjectList = []
  isBranch = false;
  filteredListBranch
  HeadList: any;
  emid: any;
  summaryData: any;
  constructor(private dialog: MatDialog,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private spinner: NgxSpinnerService) { }

   ngOnInit(): void {
     this.IAReport = this.fb.group({
       college: new FormControl(''),
       course: new FormControl(''),
       SessionId: new FormControl(''),
       Exam: new FormControl(''),
       Branch: new FormControl(''),
       EsParentId: new FormControl(''),
     });
     let id = ''
     this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
     this.fetchSession(id);
   }
 
 
   fetchCollege() {
     if (this.userPermission[0].CgUi == 'C') {
       this.UserCollege = this.userPermission[0].CgId;
     }
     else {
       this.UserCollege = ''
     }
     this.Table = false;
     this.collegeList = [];
     this.filteredCollegeList = []
 
     this.CourseList = [];
     this.filteredCourseList = [];
     this.ExamAList = [];
     this.filteredExamAList = [];
     const payload = {};
     payload['CgCode'] = this.UserCollege;
     this.umsService.getCollege(payload).subscribe(res => {
       if (res.status) {
         this.collegeList = res.data;
         this.filteredCollegeList = this.collegeList.slice();
       }
       else {
         this.spinner.hide();
         this.collegeList = []
         this.filteredCollegeList = []
       }
     }, (ERROR: HttpErrorResponse) => {
       this.spinner.hide();
       this.collegeList = []
       this.filteredCollegeList = []
 
     });
 
   }
 
 
   fetchCourse(id) {
     this.Table = false;
     this.CourseList = [];
     this.filteredCourseList = [];
     this.ExamAList = [];
     this.filteredExamAList = [];
     const payload = {};
     payload['CoCgCgCode'] = id;
     payload['SessionID'] = this.IAReport.value['SessionId'];
     this.umsService.getSessionColgCo(payload).subscribe(res => {
       if (res.status) {
         this.CourseList = res.data;
         this.filteredCourseList = this.CourseList.slice();
       }
       else {
         this.spinner.hide();
         this.CourseList = [];
         this.filteredCourseList = [];
       }
     }, (ERROR: HttpErrorResponse) => {
       this.spinner.hide();
       this.CourseList = [];
       this.filteredCourseList = [];
     });
   }
 
   fetchExam(CoCode) {
     this.spinner.show();
     this.Table = false;
     this.ExamAList = [];
     this.filteredExamAList = [];
     let payload = {};
     payload['EmCoCode'] = CoCode
     this.umsService.getExam(payload).subscribe((res) => {
       this.spinner.hide();
       if (res.status) {
         this.ExamAList = res.data;
         this.filteredExamAList = this.ExamAList.slice();
       } else {
         this.ExamAList = [];
         this.filteredExamAList = this.ExamAList.slice();
       }
     },
       (ERROR: HttpErrorResponse) => {
         this.spinner.hide();
         this.ExamAList = [];
         this.filteredExamAList = [];
       }
     );
   }
   fetchSession(id) {
     const payload = {};
     payload['SnDefault'] = id;
     payload['SnNo'] = id;
     this.umsService.getSession(payload).subscribe(res => {
       this.sessionList = [];
       if (res.status) {
         res.data.forEach(element => {
           if (element.SnStatus == 'O') {
             this.sessionList.push(element);
           }
         });
         this.SessionFilterList = this.sessionList.slice();
       }
     })
   }


   getCount(){
     let payload = {};
    payload['CgCode'] = this.IAReport.value.college;
    payload['EmId'] = this.IAReport.value.Exam;
    payload['CoCode'] = this.IAReport.value.course;
    payload['SessionId'] = this.IAReport.value.SessionId;
    payload['EsId'] =  this.IAReport.value.EsParentId
    this.umsService.getIACountClgWise(payload).subscribe((res) => {
      if (res.status) {
        this.Table = true;
       this.TotalAllStudents = res.data[0].Total;
       this.summaryData = res.data
      } else {
        this.Table = false;
        
      }

    })
   }

    fetchBranch(id) {
    this.spinner.show();
    const payload = {};
    this.filteredsubjectList = [];
    this.subjectList = [];
    this.HeadList = [];
    payload['EmId'] = id;
    this.umsService.getExamStream(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
      }
    });
  }

    getSubject(e) {
  this.getCount()
    this.spinner.show();
    this.Table = false;
    this.isBranch = false;
    this.BranchList = [];
    this.subjectList = [];
    this.filteredsubjectList = []
    this.emid = e.EmId;
    if (e.EmStreams == "Y") {
      this.spinner.hide();
      this.isBranch = true;
      this.fetchBranch(e.EmId);
      // this.emid = e.EmId;
    } else {
      this.isBranch = false;
      const payload = {};
      payload['EsEmId'] = e.EmId;
      payload['EsStrId'] = 0;
      this.umsService.getExamSubMapFetch(payload).subscribe(res => {
        this.spinner.hide();
        res.data.children.forEach(element => {

          if (element.EsType == 'S') {
            this.subjectList.push(element)
          }
          else if (element.EsType == 'G') {
            element.children.forEach(grpSub => {
              this.subjectList.push(grpSub)
            });
          }
          this.filteredsubjectList = this.subjectList.slice();

        });
      });
    }

  }

  getStr(e) {
    // this.BranchName = e.StrName
    this.spinner.show();
    this.Table = false;
    this.filteredsubjectList = [];
    this.subjectList = []
    this.HeadList = [];
    let payload = {};
    payload['EsEmId'] = this.emid;
    payload['EsStrId'] = this.IAReport.value.Branch;
    this.umsService.getExamSubMapFetch(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        res.data.children.forEach(element => {
          if (element.EsType == 'S') {
            this.subjectList.push(element)
          }
          else if (element.EsType == 'G') {
            element.children.forEach(grpSub => {
              this.subjectList.push(grpSub)
            });
          }
          this.filteredsubjectList = this.subjectList.slice();

        });
      }
      else {
        this.subjectList = [];
        this.filteredsubjectList = [];

      }

    }, (ERROR: HttpErrorResponse) => {
      this.subjectList = [];
      this.filteredsubjectList = [];
    });
  }
}
